import {useQuery} from '@tanstack/react-query';
import {fetch} from '../services/BindingDriftReconciliationService';

// FNP-585: single-record read for the detail view. Read-only — no create, update,
// or delete mutations (the binding-drift sweep owns the lifecycle).
export const useBindingDriftReport = (reportId?: string) => {

    const reportQuery = useQuery({
        queryKey: ['bindingDriftReport', reportId],
        queryFn: () => fetch(reportId!),
        enabled: !!reportId
    });

    return {
        record: reportQuery.data,
        loading: reportQuery.isLoading,
        // Surface error + fetched-but-empty so the detail page can show a "not found"
        // state instead of hanging on the loader forever when an id doesn't resolve
        // (the id is composite — `binding-drift-report:<iso>` — so a mis-encoded id
        // would not resolve; see the encodeURIComponent note in RecordsTable).
        isError: reportQuery.isError,
        notFound: reportQuery.isFetched && !reportQuery.data,
        fetchRecord: reportQuery.refetch,
    };
};
